// https://docs.sheetjs.com/docs/csf/features/formulae/#prefixed-future-functions
// Functions introduced in newer versions of Excel are prefixed with _xlfn. when stored in files.
// When writing formula expressions using these functions, the prefix is required for maximal compatibility:
// Broadest compatibility: XLSX.utils.sheet_set_array_formula(worksheet, "C1", "_xlfn.UNIQUE(A1:A3)", 1);
// Can cause errors in spreadsheet software: XLSX.utils.sheet_set_array_formula(worksheet, "C1", "UNIQUE(A1:A3)", 1);
// This list is growing with each Excel release.

const xlfnReplacements = {
	"ACOT": "_xlfn.ACOT",
	"ACOTH": "_xlfn.ACOTH",
	"AGGREGATE": "_xlfn.AGGREGATE",
	"ARABIC": "_xlfn.ARABIC",
	"BASE": "_xlfn.BASE",
	"BETA.DIST": "_xlfn.BETA.DIST",
	"BETA.INV": "_xlfn.BETA.INV",
	"BINOM.DIST": "_xlfn.BINOM.DIST",
	"BINOM.DIST.RANGE": "_xlfn.BINOM.DIST.RANGE",
	"BINOM.INV": "_xlfn.BINOM.INV",
	"BITAND": "_xlfn.BITAND",
	"BITLSHIFT": "_xlfn.BITLSHIFT",
	"BITOR": "_xlfn.BITOR",
	"BITRSHIFT": "_xlfn.BITRSHIFT",
	"BITXOR": "_xlfn.BITXOR",
	"BYCOL": "_xlfn.BYCOL",
	"BYROW": "_xlfn.BYROW",
	"CEILING.MATH": "_xlfn.CEILING.MATH",
	"CEILING.PRECISE": "_xlfn.CEILING.PRECISE",
	"CHISQ.DIST": "_xlfn.CHISQ.DIST",
	"CHISQ.DIST.RT": "_xlfn.CHISQ.DIST.RT",
	"CHISQ.INV": "_xlfn.CHISQ.INV",
	"CHISQ.INV.RT": "_xlfn.CHISQ.INV.RT",
	"CHISQ.TEST": "_xlfn.CHISQ.TEST",
	"COMBINA": "_xlfn.COMBINA",
	"CONCAT": "_xlfn.CONCAT",
	"CONFIDENCE.NORM": "_xlfn.CONFIDENCE.NORM",
	"CONFIDENCE.T": "_xlfn.CONFIDENCE.T",
	"COT": "_xlfn.COT",
	"COTH": "_xlfn.COTH",
	"COVARIANCE.P": "_xlfn.COVARIANCE.P",
	"COVARIANCE.S": "_xlfn.COVARIANCE.S",
	"CSC": "_xlfn.CSC",
	"CSCH": "_xlfn.CSCH",
	"DAYS": "_xlfn.DAYS",
	"DECIMAL": "_xlfn.DECIMAL",
	"ECMA.CEILING": "_xlfn.ECMA.CEILING",
	"ERF.PRECISE": "_xlfn.ERF.PRECISE",
	"ERFC.PRECISE": "_xlfn.ERFC.PRECISE",
	"EXPON.DIST": "_xlfn.EXPON.DIST",
	"F.DIST": "_xlfn.F.DIST",
	"F.DIST.RT": "_xlfn.F.DIST.RT",
	"F.INV": "_xlfn.F.INV",
	"F.INV.RT": "_xlfn.F.INV.RT",
	"F.TEST": "_xlfn.F.TEST",
	"FIELDVALUE": "_xlfn.FIELDVALUE",
	"FILTERXML": "_xlfn.FILTERXML",
	"FLOOR.MATH": "_xlfn.FLOOR.MATH",
	"FLOOR.PRECISE": "_xlfn.FLOOR.PRECISE",
	"FORECAST.ETS": "_xlfn.FORECAST.ETS",
	"FORECAST.ETS.CONFINT": "_xlfn.FORECAST.ETS.CONFINT",
	"FORECAST.ETS.SEASONALITY": "_xlfn.FORECAST.ETS.SEASONALITY",
	"FORECAST.ETS.STAT": "_xlfn.FORECAST.ETS.STAT",
	"FORECAST.LINEAR": "_xlfn.FORECAST.LINEAR",
	"FORMULATEXT": "_xlfn.FORMULATEXT",
	"GAMMA": "_xlfn.GAMMA",
	"GAMMA.DIST": "_xlfn.GAMMA.DIST",
	"GAMMA.INV": "_xlfn.GAMMA.INV",
	"GAMMALN.PRECISE": "_xlfn.GAMMALN.PRECISE",
	"GAUSS": "_xlfn.GAUSS",
	"HYPGEOM.DIST": "_xlfn.HYPGEOM.DIST",
	"IFNA": "_xlfn.IFNA",
	"IFS": "_xlfn.IFS",
	"IMCOSH": "_xlfn.IMCOSH",
	"IMCOT": "_xlfn.IMCOT",
	"IMCSC": "_xlfn.IMCSC",
	"IMCSCH": "_xlfn.IMCSCH",
	"IMSEC": "_xlfn.IMSEC",
	"IMSECH": "_xlfn.IMSECH",
	"IMSINH": "_xlfn.IMSINH",
	"IMTAN": "_xlfn.IMTAN",
	"ISFORMULA": "_xlfn.ISFORMULA",
	"ISO.CEILING": "_xlfn.ISO.CEILING",
	"ISOMITTED": "_xlfn.ISOMITTED",
	"ISOWEEKNUM": "_xlfn.ISOWEEKNUM",
	"LAMBDA": "_xlfn.LAMBDA",
	"LET": "_xlfn.LET",
	"LOGNORM.DIST": "_xlfn.LOGNORM.DIST",
	"LOGNORM.INV": "_xlfn.LOGNORM.INV",
	"MAKEARRAY": "_xlfn.MAKEARRAY",
	"MAP": "_xlfn.MAP",
	"MAXIFS": "_xlfn.MAXIFS",
	"MINIFS": "_xlfn.MINIFS",
	"MODE.MULT": "_xlfn.MODE.MULT",
	"MODE.SNGL": "_xlfn.MODE.SNGL",
	"MUNIT": "_xlfn.MUNIT",
	"NEGBINOM.DIST": "_xlfn.NEGBINOM.DIST",
	"NETWORKDAYS.INTL": "_xlfn.NETWORKDAYS.INTL",
	"NORM.DIST": "_xlfn.NORM.DIST",
	"NORM.INV": "_xlfn.NORM.INV",
	"NORM.S.DIST": "_xlfn.NORM.S.DIST",
	"NORM.S.INV": "_xlfn.NORM.S.INV",
	"NUMBERVALUE": "_xlfn.NUMBERVALUE",
	"PDURATION": "_xlfn.PDURATION",
	"PERCENTILE.EXC": "_xlfn.PERCENTILE.EXC",
	"PERCENTILE.INC": "_xlfn.PERCENTILE.INC",
	"PERCENTRANK.EXC": "_xlfn.PERCENTRANK.EXC",
	"PERCENTRANK.INC": "_xlfn.PERCENTRANK.INC",
	"PERMUTATIONA": "_xlfn.PERMUTATIONA",
	"PHI": "_xlfn.PHI",
	"POISSON.DIST": "_xlfn.POISSON.DIST",
	"QUARTILE.EXC": "_xlfn.QUARTILE.EXC",
	"QUARTILE.INC": "_xlfn.QUARTILE.INC",
	"QUERYSTRING": "_xlfn.QUERYSTRING",
	"RANDARRAY": "_xlfn.RANDARRAY",
	"RANK.AVG": "_xlfn.RANK.AVG",
	"RANK.EQ": "_xlfn.RANK.EQ",
	"REDUCE": "_xlfn.REDUCE",
	"RRI": "_xlfn.RRI",
	"SCAN": "_xlfn.SCAN",
	"SEC": "_xlfn.SEC",
	"SECH": "_xlfn.SECH",
	"SEQUENCE": "_xlfn.SEQUENCE",
	"SHEET": "_xlfn.SHEET",
	"SHEETS": "_xlfn.SHEETS",
	"SKEW.P": "_xlfn.SKEW.P",
	"SORTBY": "_xlfn.SORTBY",
	"STDEV.P": "_xlfn.STDEV.P",
	"STDEV.S": "_xlfn.STDEV.S",
	"SWITCH": "_xlfn.SWITCH",
	"T.DIST": "_xlfn.T.DIST",
	"T.DIST.2T": "_xlfn.T.DIST.2T",
	"T.DIST.RT": "_xlfn.T.DIST.RT",
	"T.INV": "_xlfn.T.INV",
	"T.INV.2T": "_xlfn.T.INV.2T",
	"T.TEST": "_xlfn.T.TEST",
	"TEXTJOIN": "_xlfn.TEXTJOIN",
	"UNICHAR": "_xlfn.UNICHAR",
	"UNICODE": "_xlfn.UNICODE",
	"UNIQUE": "_xlfn.UNIQUE",
	"VAR.P": "_xlfn.VAR.P",
	"VAR.S": "_xlfn.VAR.S",
	"WEBSERVICE": "_xlfn.WEBSERVICE",
	"WEIBULL.DIST": "_xlfn.WEIBULL.DIST",
	"WORKDAY.INTL": "_xlfn.WORKDAY.INTL",
	"XLOOKUP": "_xlfn.XLOOKUP",
	"XOR": "_xlfn.XOR",
	"TOROW": "_xlfn.TOROW",
	"TOCOL": "_xlfn.TOCOL",
	"TEXTSPLIT": "_xlfn.TEXTSPLIT",
	"WRAPROWS": "_xlfn.WRAPROWS",
	"WRAPCOLS": "_xlfn.WRAPCOLS",
	"TAKE": "_xlfn.TAKE",
	"DROP": "_xlfn.DROP",
	"CHOOSEROWS": "_xlfn.CHOOSEROWS",
	"CHOOSECOLS": "_xlfn.CHOOSECOLS",
	"EXPAND": "_xlfn.EXPAND",
	"SORT": "_xlfn.SORT",
	"Z.TEST": "_xlfn.Z.TEST"
};

export default xlfnReplacements;